var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"defaultImg",attrs:{"src":_vm.imageSrc,"object-fit":_vm.mode,"alt":""},on:{"error":_vm.error,"load":_vm.load}})
}
var staticRenderFns = []

export { render, staticRenderFns }